import React, { lazy, Suspense } from 'react'

import { Loader } from '../components/Loader'

const LazyTwoStepVerificationTester = lazy(() =>
  import('../pages/TwoStepVerification/Tester').then((module) => ({
    default: module.TwoStepVerificationTester,
  })),
)

export const TwoStepVerificationTesterRoute: React.FC = () => {
  return (
    <Suspense fallback={<Loader />}>
      <LazyTwoStepVerificationTester />
    </Suspense>
  )
}
